<template>
  <div>
    <div class="flex items-start flex-none space-x-4">
      <div class="flex items-center justify-center flex-none w-12 h-12 overflow-hidden border rounded bg-gray-50">
        <img v-if="product.image" :src="product.image" :alt="product.name" class="object-cover h-full">
        <fa v-else :icon="['far', 'cube']" class="text-lg text-gray-300" />
      </div>
      <div class="flex-grow">
        <div class="flex justify-between flex-grow">
          <div class="flex items-center font-semibold">
            {{ product.name }} 
          </div>
          <currency class="font-medium" :value="product.subtotal" :currency-code="account.currency" :subunits-value="true" />
        </div>
        <div class="flex text-gray-500">
          <div class="mr-2">
            &times; {{ product.quantity }} 
          </div>
          <currency :value="product.price" :currency-code="account.currency" :subunits-value="true" />
        </div>
        <div class="flex justify-between gap-4">
          <button type="button" class="py-1 text-indigo-500 hover:underline" @click="showUpdate = true">
            Adjust Quantity
          </button>
          <button type="button" class="py-1 text-red-500 hover:underline" @click="showRemove = true">
            Remove
          </button>
        </div>

        <Modal :open.sync="showUpdate" size="max-w-lg" title="Adjust Quantity">
          <div class="p-6 border-t">
            <div>
              Adjust quantity for <strong>{{ product.name }}</strong>
            </div>
            <div class="flex items-center gap-2 mt-4">
              <button 
                class="btn btn-secondary" 
                @click="quantity--">
                -
              </button>
              <input 
                readonly
                type="text" 
                class="w-20 text-center form-input" 
                :value="quantity">
              <button 
                class="btn btn-secondary" 
                @click="quantity++">
                +
              </button>
            </div>
          </div>
          <div class="flex p-6 border-t gap-x-2">
            <button class="btn btn-primary" v-submitting="submitting" @click="updateProduct">
              Done
            </button>
            <button class="btn btn-secondary" v-submitting="submitting" @click="showUpdate = false">
              Cancel
            </button>
          </div>
        </Modal>
        <Modal :open.sync="showRemove" size="max-w-lg" title="Remove Product">
          <div class="p-6">
            <div> 
              Are you sure you want to remove <strong>{{ product.name }}</strong> from this address?
            </div>
          </div>
          <div class="flex p-6 border-t gap-x-2">
            <button class="btn btn-red" v-submitting="submitting" @click="removeProduct">
              Yes, Remove It
            </button>
            <button class="btn btn-secondary" v-submitting="submitting" @click="showRemove = false">
              Cancel
            </button>
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BookingAddressProduct',

  props: {
    product: {
      type: Object,
      required: true
    },

    addressType: {
      type: String,
      required: true
    }
  },

  created () {
    this.quantity = JSON.parse(JSON.stringify(this.product.quantity))
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      submitting: false,
      showUpdate: false,
      showRemove: false,
      quantity: null
    }
  },

  methods: {
    async updateProduct () {
      try {
        this.submitting = true
        const { data } = await this.$api.patch(`account/${this.$route.params.account}/booking-${this.addressType}-products/${this.product.id}`, { quantity: this.quantity })
        this.$emit('updated', data.product)
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
        this.showUpdate = false
      }
    },

    async removeProduct () {
      try {
        this.submitting = true
        const { data } = await this.$api.delete(`account/${this.$route.params.account}/booking-${this.addressType}-products/${this.product.id}`)
        this.$emit('deleted', data.product)
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
        this.showRemove = false
      }
    }
  },

  watch: {
    quantity (newVal) {
      if (newVal < 1) {
        this.quantity = 1
      }
    }
  }
}
</script>